import { ResetPasswordDto, UsersV2Api } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';

export type resetPasswordVariables = {
  resetPasswordDto: ResetPasswordDto,
  userId: string,
};

type UseResetUserPassword = (
  usersApiV2: UsersV2Api,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, resetPasswordVariables>,
    'mutationFn'
  >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, resetPasswordVariables>;

export const useResetUserPassword: UseResetUserPassword = (
  usersApiV2,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    ({ resetPasswordDto, userId }) =>
      usersApiV2.resetUserPassword(tenantId, userId, resetPasswordDto),
    options,
  );
};
